import React from 'react';
import '@ant-design/compatible/assets/index.css';
import { Col, Row } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import TextArea from 'antd/lib/input/TextArea';
import moment from 'moment';
import Form, { FormInstance } from 'antd/lib/form/Form';

export type TabColCommentProps = {
  form?: FormInstance;
  objectid?: number;
};

const TabColComment = ({ objectid, form }: TabColCommentProps) => {
  const initialValues = {
    promcreationdate: moment(),
    promstatus: 'ACTIVE',
    promstatusdate: moment(),
    promdate: moment(),
    clientinvoice: 0,
    promamount: 0,
  };

  form?.setFieldsValue({
    promcreationdate: moment(),
    promstatus: 'ACTIVE',
    promstatusdate: moment(),
    promdate: moment(),
    clientinvoice: 0,
    promamount: 0,
  });

  return (
    <DF.Provider pagcode="TabComment">
      <Row style={{ marginTop: '20px' }}>
        <Form initialValues={initialValues} form={form} layout="vertical">
          <Col span={24}>
            <Row gutter={30}>
              <Col span={24}>
                <FormInput name="promcomment" rules={[{ required: true }]}>
                  <TextArea maxLength={255} rows={5} cols={300} />
                </FormInput>
              </Col>
            </Row>
          </Col>
        </Form>
      </Row>
    </DF.Provider>
  );
};
export default TabColComment;
